// React
import React from "react";
import { Button, MenuItem, DropdownButton } from "react-bootstrap";
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
import FlexItem from "common/ui/containers/flexContainer/FlexItem";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ReportFooter.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class ReportFooter extends React.Component {
    pageChange(index) {
        this.props.setPage(index);
    }
    render() {
        if (this.props.maxPage <= 1) {
            return React.createElement("div", null);
        }
        const maxButtons = 5;
        const maxSideButtons = 2;
        var startIndex = Math.max(this.props.currentPage - maxSideButtons, 0);
        var endIndex = Math.min(startIndex + maxButtons, this.props.maxPage);
        if (this.props.maxPage >= maxButtons && (endIndex - startIndex) <= (maxButtons - 1)) {
            startIndex = endIndex - maxButtons;
        }
        // First button
        var firstPageDisabled = this.props.currentPage > 0 ? false : true;
        // Note - it needs the space in the contents of the button (next to the span) without it, the click doesnt register - seems to be a bug in Griddle
        var firstPage = (React.createElement(Button, { bsSize: "small", disabled: firstPageDisabled, onClick: () => this.pageChange(0) },
            React.createElement("i", { className: "glyphicon glyphicon-step-backward" })));
        // Previous button
        var previousPage = (React.createElement(Button, { disabled: firstPageDisabled, onClick: this.props.previous, bsSize: "small" },
            React.createElement("i", { className: "glyphicon glyphicon-chevron-left" })));
        // Next button
        var lastPageDisabled = this.props.currentPage != (this.props.maxPage - 1) ? false : true;
        var nextPage = (React.createElement(Button, { onClick: this.props.next, disabled: lastPageDisabled, bsSize: "small" },
            React.createElement("i", { className: "glyphicon glyphicon-chevron-right" })));
        // Last button
        // Note - it needs the space in the contents of the button (next to the span) without it, the click doesnt register - seems to be a bug in Griddle
        var lastPage = (React.createElement(Button, { disabled: lastPageDisabled, bsSize: "small", onClick: () => this.pageChange(this.props.maxPage - 1) },
            React.createElement("i", { className: "glyphicon glyphicon-step-forward" })));
        // Page buttons
        var pageButtons = [];
        for (let i = startIndex; i < endIndex; i++) {
            var selected = this.props.currentPage == i ? "info" : "default";
            pageButtons.push(React.createElement(Button, { key: `key-${i}`, bsSize: "small", bsStyle: selected, "data-value": i, onClick: () => this.pageChange(i) }, i + 1));
        }
        // Dropdown
        const menuItems = [];
        for (let i = 0; i < this.props.maxPage; i++) {
            menuItems.push(React.createElement(MenuItem, { eventKey: `key-${i}`, key: `key-${i}`, "data-value": i, onClick: () => this.pageChange(i) }, i + 1));
        }
        // return
        return (React.createElement(FlexContainer, { className: styles.footer },
            React.createElement(FlexItem, { className: styles.pageCount },
                "Page ",
                this.props.currentPage + 1,
                " of ",
                this.props.maxPage),
            React.createElement(FlexItem, { className: styles.pageDropdown },
                React.createElement(DropdownButton, { dropup: true, id: "paginationDropdown", title: `Page: ${this.props.currentPage + 1}` }, menuItems)),
            React.createElement(FlexItem, { className: styles.pageButtons, flexFactor: 0 },
                firstPage,
                previousPage,
                pageButtons,
                nextPage,
                lastPage)));
    }
}
